// The service worker is only relevant for the order picking screens, which
// are used on mobile devices in the warehouse and need to force a reload
// whenever a new version is deployed. Everywhere else (desktop, other CMS
// pages) it must stay unregistered, otherwise every visitor gets prompted
// for updates and, in development, sees stale cached assets.

export const SERVICE_WORKER_SCOPE_PATH = "/cms/orders/orderpicking/";

export const isServiceWorkerScopePath = (pathname) => pathname.startsWith(SERVICE_WORKER_SCOPE_PATH);

// Routes a mobile user passes through on their way to order picking (e.g.
// right after opening the app). The service worker's scope already limits
// it to only caching order picking requests, so keeping the registration
// alive here is safe — it just avoids unregistering/re-registering on every
// app open.
const SERVICE_WORKER_KEEP_ALIVE_PATHS = ["/cms", "/cms/products", "/cms/products/product-list"];

export const isServiceWorkerKeepAlivePath = (pathname) => SERVICE_WORKER_KEEP_ALIVE_PATHS.includes(pathname);

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);

export function registerOrderPickingServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return;
  }

  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

  navigator.serviceWorker
    .register(swUrl, { scope: SERVICE_WORKER_SCOPE_PATH })
    .then((registration) => {
      console.log("[Service Worker] Registered successfully:", registration.scope);
    })
    .catch((error) => {
      console.error("[Service Worker] Registration failed:", error);
    });
}

export function unregisterAllServiceWorkers() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });

  if ("caches" in window) {
    caches.keys().then((names) => names.forEach((name) => caches.delete(name)));
  }
}

// Kept for parity with CRA's default localhost check, in case it's needed
// again for debugging service worker behaviour locally.
export { isLocalhost };
